import React from 'react';

const NotFound = () => {
    return (
        <div>
            <img src="https://cdn.dribbble.com/users/1022481/screenshots/3018253/404-snow.gif" alt="" />
        </div>
    );
};

export default NotFound;